export default "__VITE_ASSET__DXxWJFK6__"